import { HttpParams } from '@angular/common/http';

import * as querystring from 'qs';

// create http params from object, removing undefined values
export function createHttpParams(params: {}): HttpParams {
  // this will handle nested object thanks to query string
  return new HttpParams({
    fromString: querystring.stringify(params, { arrayFormat: 'brackets' }),
  });
}
